// CookieYes Helper - Ensures banner stays fixed at bottom
export const initializeCookieYes = () => {
  // Wait for CookieYes to load
  const checkCookieYes = () => {
    const banner = document.querySelector('#cookieyes-banner') || 
                  document.querySelector('.cky-consent-container') ||
                  document.querySelector('.cky-banner-container') ||
                  document.querySelector('[data-cky-tag="notice"]');
    
    if (banner) {
      // Force fixed positioning
      banner.style.position = 'fixed';
      banner.style.bottom = '0';
      banner.style.left = '0';
      banner.style.right = '0';
      banner.style.zIndex = '9999';
      banner.style.width = '100%';
      banner.style.maxWidth = '100%';
      banner.style.margin = '0';
      banner.style.transform = 'none';
      
      // Add body padding when banner is visible
      if (banner.style.display !== 'none' && !banner.classList.contains('cky-hide')) {
        document.body.classList.add('cky-consent-banner-open');
      }
      
      // Watch for banner visibility changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const target = mutation.target;
            if (target.style.display === 'none' || target.classList.contains('cky-hide')) {
              document.body.classList.remove('cky-consent-banner-open');
            } else {
              document.body.classList.add('cky-consent-banner-open');
            }
          }
        });
      });
      
      observer.observe(banner, { attributes: true, attributeFilter: ['style', 'class'] });
      
      return true;
    }
    return false;
  };
  
  // Try immediately
  if (!checkCookieYes()) {
    // If not found, wait and try again
    setTimeout(() => {
      if (!checkCookieYes()) {
        // Try one more time after a longer delay
        setTimeout(checkCookieYes, 2000);
      }
    }, 500);
  }
};

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCookieYes);
} else {
  initializeCookieYes();
}